<template>

  <div>

    <v-stepper v-model="curStep" non-linear :alt-labels="false" light>

      <!-- Stepper Headers -->
      <v-stepper-header class="grey lighten-3">

        <v-stepper-step editable :complete="curStep > 1" step="1">Scale</v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step editable :complete="curStep > 2" step="2">Pattern of Use</v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step editable :complete="curStep > 3" step="3">County</v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step editable step="4">Community</v-stepper-step>

      </v-stepper-header>

      <slot name="back-next"></slot>

      <!-- Stepper Items -->
      <v-stepper-items>

        <v-stepper-content step="1">
          <h3 class="headline">Approximate size of your household:</h3>
          <WizardStep selection-type="scale"
                      class="fill-height"
                      @increment-step="incrementStep"></WizardStep>
        </v-stepper-content>

        <v-stepper-content step="2">
          <h3 class="headline">Estimate your use pattern:</h3>
          <WizardStep selection-type="usePattern"
                      @increment-step="incrementStep"></WizardStep>
        </v-stepper-content>

        <v-stepper-content step="3">
          <h3 class="headline">Choose County:</h3>
          <WizardStep selection-type="county"
                      :items="county"
                      @increment-step="incrementStep"></WizardStep>
        </v-stepper-content>

        <v-stepper-content step="4">
          <h3 class="headline">Specify a location:</h3>
          <WizardLocations selection-type="locations"
                           :items="locations"
                           :step="curStep"
                           @increment-step="incrementStep">
          </WizardLocations>
        </v-stepper-content>

      </v-stepper-items>

    </v-stepper>

  </div>

</template>

<script>
import WizardMixin from '../views/Wizard.Mixin';
import WizardLocations from '../components/wizard/Wizard.Locations';

export default {

  name: 'Wizard.Residential',

  mixins: [WizardMixin],

  components: { WizardLocations },

  data() {
    return {
      totalSteps: 4,
      scale: this.$store.getters.scale,
      usePattern: this.$store.getters.usePattern,
      county: this.$store.getters.county,
    };
  },

  mounted() {
  },

  computed: {

    locations() {
      return this.$store.getters.locationsFiltered;
    },

  },

};

</script>
